import { makeGeoHooks } from './useGeoModeration';
import { listHotels, bulkHotels } from '../services/hotels';

const hooks = makeGeoHooks('hotels', {
  list: listHotels,
  bulk: bulkHotels,
});

export const useHotels = hooks.useList;
export const useBulkHotels = hooks.useBulk;
